import { cn } from '@nexus/ui';
import type { CompanySummary } from '../api/types';

/** Logo of a company, or its initials when it has none. Decorative: the name stands next to it. */
export function CompanyMark({
  company,
  size = 'md',
}: {
  company: Pick<CompanySummary, 'name' | 'shortName' | 'logo'>;
  size?: 'md' | 'lg';
}) {
  const box = size === 'lg' ? 'size-10' : 'size-7';
  if (company.logo) {
    return (
      <img src={company.logo} alt="" className={cn(box, 'shrink-0 rounded-sm object-contain')} />
    );
  }
  // Short names like "STE" stay whole, long names give their initials.
  const short = company.shortName && company.shortName.length <= 3 ? company.shortName : null;
  const letters = (
    short ??
    (company.shortName ?? company.name)
      .split(/[\s&-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((word) => word[0])
      .join('')
  ).toUpperCase();
  return (
    <span
      aria-hidden
      className={cn(
        box,
        'flex shrink-0 items-center justify-center rounded-sm bg-brand-solid font-semibold text-brand-solid-fg',
        size === 'lg' ? 'text-sm' : letters.length > 2 ? 'text-2xs' : 'text-xs',
      )}
    >
      {letters}
    </span>
  );
}
